<template>
    <form
        :action="autocompleteUrl"
        v-on:submit.prevent="redirectToSearch"
        method="get"
        accept-charset="utf-8"
        class="c-form"
    >
        <i class="ico ico-shadow-search"><i class="path1"></i><i class="path2"></i></i>

        <div class="c-form__item c-form__item--text">
            <input
                type="text"
                :id="'autocomplete-' + parseInt(Math.random() * 1000)"
                v-model="keyword"
                name="search"
                autocomplete="off"
                :placeholder="inputPlaceholder"
                @focus="showForm"
                @keyup.enter="redirectToSearch"
                :class="{
                    'c-form__input js-search-input': true,
                    'is-empty': !keyword,
                    'is-open': isOpen
                }"
                ref="searchInput"
            />
        </div>

        <a
            v-if="!isFormVisible"
            :href="searchUrl"
            class="c-btn c-btn--secondary"
            :class="{
                'is-open': isOpen
            }"
        >
            <i class="ico ico-search cxs-is-visible xs-is-visible"></i>
            <span class="cxs-is-hidden xs-is-hidden">{{ $t('Autocomplete.Header.buttonText') }}</span>
        </a>

        <button v-else type="button" @click="hideForm" :class="{
            'c-btn c-btn--square c-btn--close': true,
            'is-open': isOpen
        }">
            <i aria-hidden="true" class="ico ico-close-thick"></i>
        </button>
    </form>
</template>

<script>
export default {
    props: {
        isFormVisible: {
            type: Boolean,
            default: false,
        },
        isOpen: {
            type: Boolean,
            default: false,
        },
        inputPlaceholder: {
            type: String,
            required: true
        },
        autocompleteUrl: {
            type: String,
            default: "/search/autocomplete",
        },
        placeholder: {
            type: String,
            default: "Search",
        },
    },
    data() {
        return {
            keyword: new URL(window.location.href).searchParams.get('search'),
        }
    },
    methods: {
        showForm() {
            this.$emit('show-form')
        },
        hideForm() {
            this.$emit('hide-form')
        },
        redirectToSearch() {
            window.location.href = this.searchUrl
        }
    },
    computed: {
        searchUrl() {
            return `/vyhladavanie${this.keyword ? `?search=${this.keyword}` : ''}`
        }
    },
    watch: {
        isFormVisible(value) {
            if (value) {
                this.$nextTick(() => {
                    this.$refs.searchInput.focus()
                })
            }
        }
    }
};
</script>